function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Button, ChipButton, ConfirmationModal, DropdownMenu, FilterPickerGroup, Page, PageContentHeader, PageEmptyState, PageErrorState, Searchbox, TableList, TableListActions, TextField, Typography, useStateInRef } from 'seagull';
import { NoTemplatesIcon } from "./NoTemplatesIcon";
import RestfulWrapper from "../../components/RestfulWrapper/RestfulWrapper";
import { useEventReporter, useGlobalContext, useIoContext, useStore, useStoreActions } from "../../contexts";
import { contactModel, proposalTemplateModel, timeModel } from "../../models";
import PageLoadingState from "../../components/PageLoadingState";
import { useInfiniteScroll } from "../../hooks/useInfiniteScroll";
import countBy from 'lodash/countBy';
import compact from 'lodash/compact';
import { useSortFromUrl } from "../../hooks/useSortFromUrl";
import { EditLine, ReceiptEditLiner24, TrashLiner24, WideArrowDownward, WideArrowUpward } from 'seagull/icons';
import styles from "./ProposalTemplates.module.scss";
import { useStateFromUrl } from 'seagull/utils/useStateFromUrl';
import isEmpty from 'lodash/isEmpty';
import mapValues from 'lodash/mapValues';
import { useHistory } from 'react-router-dom';
import { routes } from "../../constants";
import { ClientPreview } from "../../components/ClientPreview/ClientPreview";
import { selectors } from "../../store/state-selectors";
import { Intent } from "../../infra/access-control";
import ExternalLinkButton from "../../components/ExternalLinkButton";
import { getHelpArticle, handlePromise, numberAndUnit } from "../../infra/utils";
import { useBulkActionModal } from "../../hooks/useTerminateAgreement/useBulkActionModal";
import { makeSentryIgnoredError } from "../../components/ErrorBoundaryPage";
import { ServerError } from "../../infra/ErrorResponse";
const title = 'Proposal templates';
export let HeaderColId = /*#__PURE__*/function (HeaderColId) {
  HeaderColId["name"] = "name";
  HeaderColId["lastUpdatedOn"] = "lastUpdatedOn";
  return HeaderColId;
}({});
function getTableDefs() {
  const defs = compact([{
    headerItem: {
      id: HeaderColId.name,
      value: 'Template name'
    },
    columnDef: {
      width: [180, 500],
      sortable: true
    }
  }, {
    headerItem: {
      id: HeaderColId.lastUpdatedOn,
      value: 'Last Updated On'
    },
    columnDef: {
      width: [180, 500],
      sortable: true
    }
  }]);
  return {
    columnDefs: defs.map(d => d.columnDef),
    headerItems: defs.map(d => d.headerItem)
  };
}
const sortFunctions = {
  [HeaderColId.name]: _ref => {
    let {
      isAscending
    } = _ref;
    return (a, b) => {
      const retval = sortByName(a, b) || sortById(a, b);
      return isAscending ? retval : -retval;
    };
  },
  [HeaderColId.lastUpdatedOn]: _ref2 => {
    let {
      isAscending
    } = _ref2;
    return (a, b) => {
      const retval = sortByLastUpdatedOnDate(a, b) || sortById(a, b);
      return isAscending ? retval : -retval;
    };
  }
};
const sortById = (a, b) => a.id < b.id ? -1 : 1;
function sortByName(a, b) {
  const nameA = a.title.toLowerCase();
  const nameB = b.title.toLowerCase();
  if (nameA < nameB) {
    return -1;
  } else if (nameA > nameB) {
    return 1;
  } else return 0;
}
function sortByLastUpdatedOnDate(a, b) {
  return a.lastUpdatedOn.getTime() - b.lastUpdatedOn.getTime();
}
function sortProposalTemplates(config) {
  const {
    templates,
    sort,
    headerItems
  } = config;
  const result = templates.slice();
  if (sort) {
    var _headerItems$sort$col;
    const colId = (_headerItems$sort$col = headerItems[sort.colIndex]) === null || _headerItems$sort$col === void 0 ? void 0 : _headerItems$sort$col.id;
    if (colId) {
      result.sort(sortFunctions[colId]({
        isAscending: sort.sort === 'asc'
      }));
    }
  }
  return result;
}
export const CreateTemplateButton = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    reportButtonClick
  } = useEventReporter();
  const history = useHistory();
  return /*#__PURE__*/React.createElement(Button, {
    ref: ref,
    "data-intercom-target": 'Create proposal template',
    onClick: async () => {
      reportButtonClick('create-template');
      //await openCreationModal();
      history.push(routes.proposalTemplateStudio);
    },
    "data-testid": "proposal-templates-empty-new-btn"
  }, "Create template");
});
function EmptyState(_ref3) {
  let {
    isRefreshing
  } = _ref3;
  return /*#__PURE__*/React.createElement(Page, {
    header: title,
    loading: isRefreshing
  }, /*#__PURE__*/React.createElement(PageEmptyState, {
    "data-testid": "proposal-templates-empty",
    illustration: /*#__PURE__*/React.createElement(NoTemplatesIcon, null),
    title: "Speed up your workflow with Proposal Templates",
    message: 'Tip: a template can also be created by selecting "Save as template" when creating a proposal.',
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CreateTemplateButton, null), /*#__PURE__*/React.createElement(ExternalLinkButton, {
      openInNewTab: true,
      testid: "proposal-templates-learn-more",
      underline: "hover",
      href: getHelpArticle('8512622-proposal-templates')
    }, "Learn more about Proposal Templates"))
  }));
}
function ProposalTemplatesRow(props) {
  const {
    template,
    onUseTemplate,
    onPreview,
    onEdit,
    onRename,
    onRemove
  } = props;
  const testId = 'proposal-templates-row';
  const heapId = 'proposal-templates-row';
  const items = compact([{
    value: /*#__PURE__*/React.createElement("div", {
      className: styles.title
    }, /*#__PURE__*/React.createElement(Typography, {
      ellipsis: true,
      weight: "normal",
      "data-testid": "proposal-template-name"
    }, template.title))
  }, {
    value: /*#__PURE__*/React.createElement("div", {
      className: styles.title
    }, /*#__PURE__*/React.createElement(Typography, {
      ellipsis: true,
      "data-testid": "proposal-template-last-updated-on"
    }, timeModel.formatDateWithTime(template.lastUpdatedOn)))
  }]);
  return /*#__PURE__*/React.createElement(TableList.Row, {
    as: 'button',
    onClick: () => onUseTemplate(template),
    items: items,
    rowId: template.id,
    "data-testid": testId,
    "data-heapid": heapId,
    actionColumn: /*#__PURE__*/React.createElement(TableListActions, {
      testId: "proposal-templates-row-actions",
      menuHeapId: "proposal-templates-row-actions-menu-btn",
      buttonText: "Use template",
      secondaryButtonText: "Preview",
      secondaryBtnHeapId: "".concat(heapId, "-preview-template-btn"),
      onClickButton: () => onUseTemplate(template),
      onClickSecondaryButton: () => onPreview(template)
    }, /*#__PURE__*/React.createElement(DropdownMenu.Item, {
      iconStart: /*#__PURE__*/React.createElement(ReceiptEditLiner24, null),
      "data-testid": "".concat(testId, "-edit-menu-action"),
      "data-heapid": "".concat(heapId, "-menu-edit-menu-action"),
      onClick: () => onEdit(template),
      intent: Intent.EditProposalTemplate
    }, "Edit"), /*#__PURE__*/React.createElement(DropdownMenu.Item, {
      iconStart: /*#__PURE__*/React.createElement(EditLine, null),
      "data-testid": "".concat(testId, "-rename-menu-action"),
      "data-heapid": "".concat(heapId, "-menu-rename-menu-action"),
      onClick: () => onRename(template),
      intent: Intent.RenameProposalTemplate
    }, "Rename"), /*#__PURE__*/React.createElement(DropdownMenu.Item, {
      iconStart: /*#__PURE__*/React.createElement(TrashLiner24, null),
      skin: "error",
      "data-testid": "".concat(testId, "-remove-menu-action"),
      "data-heapid": "".concat(heapId, "-menu-remove-menu-action"),
      onClick: () => onRemove(template),
      intent: Intent.RemoveProposalTemplate
    }, "Remove"))
  });
}
function ProposalTemplatesTable(props) {
  const {
    proposalTemplates,
    legalTermsDocs,
    search,
    onChangeSearch,
    refresh
  } = props;
  const {
    api
  } = useStoreActions();
  const scrollElRef = useRef(null);
  const inputDebounceTime = useStore(state => state.appConfig.inputDebounceTime);
  const globalContext = useGlobalContext();
  const history = useHistory();
  const {
    getNow
  } = useIoContext();
  const worksAt = useStore(selectors.user.business);
  const {
    doBulkAction
  } = useBulkActionModal();
  const {
    headerItems,
    columnDefs
  } = useMemo(() => getTableDefs(), []);
  const sortIds = useMemo(() => headerItems.map(item => item.id), [headerItems]);
  const defaultSort = useMemo(() => ({
    colIndex: 1,
    sort: 'desc'
  }), []);
  const {
    sort,
    changeSort
  } = useSortFromUrl({
    defaultSort,
    sortIds
  });
  const [selected, setSelected] = useState({});
  const getSelected = useStateInRef(selected);
  const [bulkActionsOpen, setBulkActionsOpen] = useState(false);
  const numSelected = useMemo(() => {
    var _countBy$true;
    return (_countBy$true = countBy(selected).true) !== null && _countBy$true !== void 0 ? _countBy$true : 0;
  }, [selected]);
  const onSortChange = sort => {
    changeSort(sort);
  };
  const sortedProposalTemplates = useMemo(() => {
    return sortProposalTemplates({
      templates: proposalTemplates,
      sort,
      headerItems
    });
  }, [sort, proposalTemplates, headerItems]);
  const {
    paginatedData,
    onScroll
  } = useInfiniteScroll({
    data: sortedProposalTemplates,
    scrollElRef
  });
  const onToggleAllSelection = useCallback(selectAll => {
    setSelected(proposalTemplates.reduce((acc, _ref4) => {
      let {
        id
      } = _ref4;
      return Object.assign(acc, {
        [id]: selectAll
      });
    }, {}));
  }, [proposalTemplates]);
  function getSelectedProposalTemplates() {
    return Object.entries(selected).filter(_ref5 => {
      let [, isSelected] = _ref5;
      return isSelected;
    }).map(_ref6 => {
      let [proposalTemplateId, _] = _ref6;
      return proposalTemplateId;
    });
  }
  async function bulkRemove(selectedProposalTemplates) {
    await doBulkAction({
      bulkItemIds: selectedProposalTemplates,
      confirmationTitle: 'Remove templates',
      confirmationPrimaryButtonLabel: 'Send Request',
      confirmationContent: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, null, "Are you sure you want to remove", ' ', /*#__PURE__*/React.createElement(Typography, {
        "data-testid": "proposal-template-remove-modal-template-name",
        as: "span",
        weight: "bold"
      }, selectedProposalTemplates.length), ' ', "templates?"), /*#__PURE__*/React.createElement(Typography, null, "This action cannot be undone.")),
      progressTitle: 'Remove templates',
      actionName: 'removed',
      itemName: 'template',
      onConfirmed: () => {},
      canProcessItem: () => true,
      processSingleItem: proposaltemplateId => handlePromise(api.proposalTemplates.remove(proposaltemplateId)).then(result => [result.data, null, !result.success]),
      onDone: failedProposalTemplateIds => {
        setSelected(failedProposalTemplateIds.reduce((acc, templateId) => _objectSpread(_objectSpread({}, acc), {}, {
          [templateId]: true
        }), {}));
      }
    });
    refresh();
  }
  const onUseTemplate = async template => {
    const draftId = await api.proposalTemplates.createDraft(template.id);
    history.push(routes.draft(draftId));
  };
  const onPreview = async summary => {
    const template = await api.proposalTemplates.get(summary.id);
    const draft = proposalTemplateModel.toPreviewData(template);
    const sampleContact = contactModel.makeSampleContact({
      createdAt: getNow(),
      vendorId: worksAt === null || worksAt === void 0 ? void 0 : worksAt.id
    });
    globalContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: props => /*#__PURE__*/React.createElement(ClientPreview, _extends({
        type: "draft",
        draftInfo: {
          draft,
          contactsMap: {},
          sampleContact,
          legalTerms: legalTermsDocs
        }
      }, props))
    });
  };
  const onEdit = template => {
    history.push(routes.proposalTemplate(template.id));
  };
  const onRename = async _ref7 => {
    let {
      id,
      title
    } = _ref7;
    const newName = await globalContext.showModal({
      content: function RenameModal(_ref8) {
        let {
          dismissModal
        } = _ref8;
        const [newName, setNewName] = useState(title);
        return /*#__PURE__*/React.createElement(ConfirmationModal, {
          title: "Rename template",
          "data-testid": "proposal-template-rename-modal",
          content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextField, {
            testid: "proposal-template-rename-modal-input",
            name: "Template name",
            value: newName,
            onChange: e => {
              setNewName(e.target.value);
            }
          })),
          primaryButtonLabel: "Save",
          onPrimaryButtonClick: () => dismissModal(newName),
          secondaryButtonLabel: "Cancel",
          onSecondaryButtonClick: () => dismissModal(null),
          onCloseButtonClick: () => dismissModal(null)
        });
      }
    });
    if (newName) {
      api.proposalTemplates.rename(id, newName).then(() => refresh()).catch(e => {
        if (e.response.data.error === ServerError.NameAlreadyExists) globalContext.showErrorToast('A template with this name already exists.', 'duplicate-template-name-error');
      });
    }
  };
  const onRemove = async _ref9 => {
    let {
      id,
      title
    } = _ref9;
    const doRemove = await globalContext.showModal({
      content: _ref10 => {
        let {
          dismissModal
        } = _ref10;
        return /*#__PURE__*/React.createElement(ConfirmationModal, {
          title: "Remove template",
          skin: "danger",
          textAlignCenter: false,
          "data-testid": "proposal-template-remove-modal",
          content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, null, "Are you sure you want to remove", ' ', /*#__PURE__*/React.createElement(Typography, {
            "data-testid": "proposal-template-remove-modal-template-name",
            as: "span",
            weight: "bold"
          }, title), ' ', "from your templates?"), /*#__PURE__*/React.createElement(Typography, null, "This action cannot be undone.")),
          primaryButtonLabel: "Remote template",
          onPrimaryButtonClick: () => dismissModal(true),
          secondaryButtonLabel: "Cancel",
          onSecondaryButtonClick: () => dismissModal(false),
          onCloseButtonClick: () => dismissModal(false)
        });
      }
    });
    if (doRemove) {
      api.proposalTemplates.remove(id).then(() => refresh());
    }
  };
  useEffect(() => {
    // this unselects any proposal template that is not found in the newly fetched list of proposal templates
    if (!proposalTemplates || isEmpty(getSelected())) return;
    const ids = proposalTemplates.map(proposalTemplate => proposalTemplate.id);
    const newSelected = mapValues(getSelected(), (origValue, proposalTemplateId) => ids.includes(proposalTemplateId) ? origValue : false);
    setSelected(newSelected);
  }, [proposalTemplates]);
  return /*#__PURE__*/React.createElement(Page, {
    "data-testid": "proposal-templates-table",
    header: title,
    ref: scrollElRef,
    actions: /*#__PURE__*/React.createElement(CreateTemplateButton, {
      key: "new-proposal-template-button"
    }),
    subheader: numberAndUnit(proposalTemplates.length, 'templates'),
    onScroll: onScroll
  }, /*#__PURE__*/React.createElement(TableList.Provider, {
    hasActionColumn: true,
    enableRowSelection: true,
    columnDefs: columnDefs,
    selectedRows: selected,
    sort: sort,
    onSortChange: onSortChange,
    onSelectionChange: setSelected,
    numRows: proposalTemplates.length,
    numSelectedRows: numSelected,
    onToggleAllSelection: onToggleAllSelection
  }, /*#__PURE__*/React.createElement(PageContentHeader, null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBlockEnd: '24px'
    }
  }, /*#__PURE__*/React.createElement(FilterPickerGroup, {
    flexWrap: true,
    "data-testid": "proposal-templates-dashboard-filters"
  }, /*#__PURE__*/React.createElement(Searchbox, {
    registerHotkey: true,
    value: search,
    "data-testid": "proposal-templates-search",
    debounceTime: inputDebounceTime !== null && inputDebounceTime !== void 0 ? inputDebounceTime : 500,
    onClear: () => onChangeSearch(''),
    onChange: event => {
      const searchStr = event.target.value;
      onChangeSearch(searchStr);
    }
  }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    className: styles.selectedItems,
    "data-testid": "proposalTemplate-dashboard-bulk-counter"
  }, numSelected > 0 ? "".concat(numberAndUnit(numSelected, 'template'), " selected") : ''), /*#__PURE__*/React.createElement(DropdownMenu, {
    onOpenChange: setBulkActionsOpen,
    target: /*#__PURE__*/React.createElement(ChipButton, {
      "data-testid": "proposal-templates-bulk-actions",
      suffixIcon: bulkActionsOpen ? /*#__PURE__*/React.createElement(WideArrowUpward, null) : /*#__PURE__*/React.createElement(WideArrowDownward, null),
      highlight: bulkActionsOpen,
      disabled: numSelected === 0
    }, "Bulk actions")
  }, /*#__PURE__*/React.createElement(DropdownMenu.Item, {
    iconStart: /*#__PURE__*/React.createElement(TrashLiner24, null),
    skin: "error",
    intent: Intent.RemoveProposalTemplate,
    "data-testid": "proposal-templates-bulk-remove",
    onClick: () => bulkRemove(getSelectedProposalTemplates())
  }, "Remove"))))), /*#__PURE__*/React.createElement(TableList.Header, {
    items: headerItems,
    "data-testid": "proposal-templates-table-header"
  })), paginatedData.map(proposalTemplate => /*#__PURE__*/React.createElement(ProposalTemplatesRow, {
    key: proposalTemplate.id,
    template: proposalTemplate,
    onUseTemplate: onUseTemplate,
    onPreview: onPreview,
    onEdit: onEdit,
    onRename: onRename,
    onRemove: onRemove
  }))));
}
export function ProposalTemplates() {
  const {
    api,
    fetchLegalTerms
  } = useStoreActions();
  const shouldRefresh = useRef(false);
  const refreshRef = useRef(() => {});
  const {
    urlState,
    changeUrlState
  } = useStateFromUrl({
    search: {
      defaultValue: ''
    }
  });
  const {
    search
  } = urlState;
  useEffect(() => {
    document.title = title;
  }, []);
  useEffect(() => {
    if (shouldRefresh.current) {
      refreshRef.current();
    }
  }, [urlState]);
  return /*#__PURE__*/React.createElement(RestfulWrapper, {
    fetch: () => Promise.all([api.proposalTemplates.getAll().then(templateSummary => templateSummary.filter(_ref11 => {
      let {
        title
      } = _ref11;
      return title.toLowerCase().includes(search.toLowerCase());
    })), fetchLegalTerms().then(legalTerms => {
      if (!legalTerms) throw makeSentryIgnoredError('legalTermsError');
      return legalTerms;
    })]).then(_ref12 => {
      let [proposalTemplates, legalTermsDocs] = _ref12;
      return {
        proposalTemplates,
        legalTermsDocs
      };
    }),
    renderLoader: () => /*#__PURE__*/React.createElement(PageLoadingState, {
      header: title,
      loading: true
    }),
    renderError: _ref13 => {
      let {
        refresh
      } = _ref13;
      return /*#__PURE__*/React.createElement(PageErrorState, {
        title: title,
        onRefresh: refresh
      });
    },
    renderChild: _ref14 => {
      let {
        data: {
          proposalTemplates,
          legalTermsDocs
        },
        loading,
        refresh
      } = _ref14;
      refreshRef.current = refresh;
      if (proposalTemplates.length === 0 && !search) {
        return /*#__PURE__*/React.createElement(EmptyState, {
          isRefreshing: loading
        });
      }
      return /*#__PURE__*/React.createElement(ProposalTemplatesTable, {
        proposalTemplates: proposalTemplates,
        legalTermsDocs: legalTermsDocs,
        refresh: refresh,
        isRefreshing: loading,
        search: search,
        onChangeSearch: search => {
          refreshOnUrlStateChange();
          changeUrlState({
            search
          });
        }
      });
      function refreshOnUrlStateChange() {
        shouldRefresh.current = true;
      }
    }
  });
}